var App = App || {};

App.Header = (function ($) {
    'use strict';

    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 300;

        const mmContainer = $("header .header-primary > nav > ul");
        const mmTrigger = mmContainer.children("li").children("a, button");
        const mmItems = mmContainer.find(".mega-menu").find("a");

        let mmActiveItems = [];
        let mmActiveItem = 0;

        mmItems.attr("tabindex", -1);

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            MegaMenuClose(mmTrigger, mmSpeed);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                mmActive = false;
                MegaMenuClose($(this).children("li").children("a, button"), 1);
            }
        });

        mmTrigger.on("mouseenter", function () {
            MegaMenuOpen($(this), mmActive ? 1 : mmSpeed);
            mmActive = true;
        }).on("focus", function () {
            MegaMenuOpen($(this), 1);
            mmActive = true;
        }).on("blur", function () {
            if (mmActive === false) {
                MegaMenuClose($(this), 1);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItems = [];
                    mmActiveItem = 0;
                    $(this).siblings(".mega-menu").find("a:visible").each(function () { mmActiveItems.push(this); });
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    MegaMenuClose($(this), mmSpeed);
                    break;
            }
        });

        mmItems.on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".mega-menu").parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    mmActive = true;
                    $(this).parents(".mega-menu").parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem < mmActiveItems.length - 1 ? mmActiveItem + 1 : 0;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    mmActive = true;
                    mmActiveItem = mmActiveItem > 0 ? mmActiveItem - 1 : mmActiveItems.length - 1;
                    $(mmActiveItems[mmActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, megaMenuSpeed);
                    break;
            }
        });

    }

    function MegaMenuOpen(trigger, speed) {
        trigger.attr("aria-expanded", "true").siblings(".mega-menu").stop().slideDown(speed);
        MegaMenuClose(trigger.parents("li").siblings("li").children("a, button"), speed);
    }

    function MegaMenuClose(trigger, speed) {
        trigger.attr("aria-expanded", "false").siblings(".mega-menu").stop().slideUp(speed);
    }

    return {
        MegaMenu: MegaMenu
    };

})(jQuery);